module.exports = __webpack_public_path__ + "media/GLAMPING_7.6ec9ebf3.webm";